import React from 'react'
import { NavLink ,useHistory} from 'react-router-dom'

const About = () => {
    const history = useHistory(); // useHistory hook'unu burada kullanın

    const handleLinkClick = () => {
      window.scrollTo(0, 0);
    };
    return (
        <section>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5 mb-4 my-md-auto">
                        <img src="./../images/Images.png" className="w-100" alt="Hakkımızda" />
                    </div>
                    <div className="col-md-7 col-lg-6 my-auto pl-lg-5">
                        <p className="semi-bold font__size--14 text__14-1024 color__orange text-uppercase">Hakkımızda</p>
                        <h3 className="bold font__size--58 text__50-1024 text__50-sm text__50-xs text-uppercase">Her Tel İşte Bir Adım Ötesi!</h3>
                        <p className="roboto semi-bold font__size--16 text__16-1024">1994'ten beri yılları aşkın tecrübemizle</p>
                        <p className="roboto normal font__size--16 text__16-1024 color__gray-1">Çıraklığına başladığımız tel çit sistemleri işini kendimizi geliştirerek geldiğimiz bugün, tel örme ustalığından metal ustalığına, tel çit montajı, halı saha ve kapı imalat montajına kadar siz değerli müşterilerimizin hayallerini gerçekleştiriyoruz. Deneyimli işçiliğimiz ile baş koyduğumuz bu yolda kaliteli malzemeyi eksik etmemekteyiz. Eymen Tel Çit Sistemleri 1994’ten bugüne siz değerli müşterilerimiz, kurduğunuz hayalleri gerçeğe dökmek için çaba göstermekteyiz.</p>
                       
                        <NavLink
                            to="/hakkimizda" className="semi-bold rounded-0 font__size--14 text__14-1024 btn btn__orange shadow color__white text-uppercase" onClick={handleLinkClick}>Hakkımızda</NavLink>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About